import { Cookies, LocalStorage, Platform } from 'quasar'
import type { CookieOptions } from 'src/types'

const COOKIE_OPTIONS: CookieOptions = {
  path: '/',
  expires: 365 * 5,
  sameSite: 'Lax',
  secure: true,
  domain: process.env.DOMAIN,
}

export const MyStorage = {
  get: Platform.is.capacitor ? LocalStorage.getItem : Cookies.get,
  remove: (key: string) => Platform.is.capacitor ? LocalStorage.remove(key) : Cookies.remove(key, COOKIE_OPTIONS),
  has: (key: string) => (Platform.is.capacitor ? LocalStorage.has(key) : Cookies.has(key)) && !!MyStorage.get(key),
  set: (key: string, value: string) => Platform.is.capacitor ? LocalStorage.set(key, value) : Cookies.set(key, value, COOKIE_OPTIONS),
}
